// MobileChips — fila horizontal de chips de categoria (touch). Parede A5.
//
// Scroll horizontal nativo (overflow-x:auto + momentum), sem foco de remoto.
// Cada chip é um <button> (alvo de toque >= 44px no CSS) com data-active pro
// estado selecionado e pros testes. O componente é "burro": recebe a lista de
// chips já montada (buildCatalogChips, puro) + o id ativo + o handler de tap.

import type { CatalogChip } from './mobile-catalog'
import { isChipActive } from './mobile-catalog'
import styles from './MobileChips.module.css'

export interface MobileChipsProps {
  chips: ReadonlyArray<CatalogChip>
  /** id selecionado (null = "Todos"). */
  activeId: string | null
  /** Tap num chip — passa o id (null = "Todos"). */
  onSelect: (id: string | null) => void
  /** Rótulo acessível da barra (i18n no caller). */
  ariaLabel: string
}

export function MobileChips({
  chips,
  activeId,
  onSelect,
  ariaLabel,
}: MobileChipsProps): JSX.Element {
  return (
    <div className={styles.chips} role="tablist" aria-label={ariaLabel}>
      {chips.map((chip) => {
        const active = isChipActive(chip.id, activeId)
        return (
          <button
            key={chip.id ?? '__all__'}
            type="button"
            role="tab"
            className={styles.chip}
            data-chip={chip.id ?? 'all'}
            data-active={active ? 'true' : 'false'}
            aria-selected={active ? 'true' : 'false'}
            onClick={() => onSelect(chip.id)}
          >
            {chip.label}
          </button>
        )
      })}
    </div>
  )
}
